import {
  BIRDVIEW_CHART_CATALOG_ALL_TAB,
  BIRDVIEW_CHART_CATALOG_ALL_TAB_OPTION,
  BIRDVIEW_CHART_CATALOG_OBJECTS,
} from './BirdviewChartCatalog.constants'

function checkHasBirdviewChartCatalogObject(rows, object) {
  return rows.some(row => row.object === object)
}

function checkIsBirdviewChartCatalogAllTab(tab) {
  return tab === BIRDVIEW_CHART_CATALOG_ALL_TAB
}

function checkIsBirdviewChartCatalogRowFound(row, query) {
  return `${row.title} ${row.question}`.toLowerCase().includes(query)
}

export function getBirdviewChartCatalogTabs(rows) {
  return [
    BIRDVIEW_CHART_CATALOG_ALL_TAB_OPTION,
    ...BIRDVIEW_CHART_CATALOG_OBJECTS.filter(object =>
      checkHasBirdviewChartCatalogObject(rows, object.value)
    ),
  ]
}

export function getBirdviewChartCatalogActiveTab({ rows, tab }) {
  return checkHasBirdviewChartCatalogObject(rows, tab)
    ? tab
    : BIRDVIEW_CHART_CATALOG_ALL_TAB
}

export function getBirdviewChartCatalogGroups({ rows, search, tab }) {
  const query = search.trim().toLowerCase()

  return BIRDVIEW_CHART_CATALOG_OBJECTS.filter(
    object => checkIsBirdviewChartCatalogAllTab(tab) || object.value === tab
  )
    .map(object => ({
      ...object,
      rows: rows.filter(
        row =>
          row.object === object.value &&
          checkIsBirdviewChartCatalogRowFound(row, query)
      ),
    }))
    .filter(group => group.rows.length > 0)
}
